import { render, staticRenderFns } from "./ThanksStepComponent.vue?vue&type=template&id=c5860096"
import script from "./ThanksStepComponent.vue?vue&type=script&lang=ts"
export * from "./ThanksStepComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports